import {
   Button,
   Checkbox,
   Divider,
   Flex,
   FormControl,
   FormLabel,
   HStack,
   IconButton,
   Input,
   Modal,
   ModalBody,
   ModalCloseButton,
   ModalContent,
   ModalFooter,
   ModalHeader,
   ModalOverlay,
   NumberDecrementStepper,
   NumberIncrementStepper,
   NumberInput,
   NumberInputField,
   NumberInputStepper,
   Select,
   Stack,
   TabPanel,
   TabPanels,
   Tabs,
   Text,
   useDisclosure,
   useToast,
} from "@chakra-ui/react";
import React, { FC, useState } from "react";
import { AiFillEdit } from "react-icons/ai";
import { IoIosAddCircle } from "react-icons/io";
import {
   IAnnounce,
   IApp,
   IType,
} from "../../ts/interfaces/announces_interface";
import axios from "axios";
import { IUser } from "../../ts/interfaces/user_interface";
import { useAuth } from "../../context/auth";
import { INode } from "../../ts/interfaces/node_interface";
import ApplicationCard from "./ApplicationCard";
import ApplicationEdit from "./ApplicationEdit";
import ApplicationForm from "./ApplicationForm";

interface EditInstanceProps {
   ins: IAnnounce;
   onEdit: () => void;
}

export const EditInstance: FC<EditInstanceProps> = ({ ins, onEdit }) => {
   const { isOpen, onOpen, onClose } = useDisclosure();
   const { user, isAdmin } = useAuth();
   const [ip, setIP] = useState("");
   const [types, setTypes] = useState<IType[]>([]);
   const [users, setUsers] = useState<IUser[]>([]);
   const [apps, setApps] = useState<IApp[]>([]);
   const [select, setSelect] = useState<IType | null>(null);
   const [load, setLoad] = useState(false);
   const [owner, setOwner] = useState<IUser | null>(ins.user);
   const toast = useToast();
   const [ingress, setIngress] = useState<number>(0);

   const [nodeList, setNodeList] = useState<INode[]>([]);
   const [announce_node_ids, setAnnounceNodeIds] = useState<string[]>([]);

   const [tabIndex, setTabIndex] = useState(0);
   const [edit, setEdit] = useState<IApp>();
   const [editIndex, setEditIndex] = useState<number>();

   const fetchNode = () => {
      if (!isAdmin) return;
      setLoad(true);
      axios
         .get<{
            nodes: INode[];
            meta: {
               limit: number;
               total: number;
            };
         }>(`/admin/nodes`)
         .then(({ data }) => {
            setNodeList(data.nodes);
            setLoad(false);
         });
   };

   return (
      <>
         <IconButton
            colorScheme="warning"
            icon={<AiFillEdit />}
            aria-label={"Add"}
            disabled={ins.mark_delete || ins.lock}
            onClick={() => {
               setLoad(true);
               fetchNode();

               Promise.all([
                  axios.get<{
                     apps: IApp[];
                  }>(`/announces/instances/${ins.id}`),
                  axios.get<{
                     types: IType[];
                  }>("/announces/apps/types"),
                  isAdmin
                     ? axios.get<{
                          users: IUser[];
                       }>("/admin/users?limit=-1")
                     : Promise.resolve(null),
               ])
                  .then((values) => {
                     setOwner(ins.user);
                     setApps(values[0].data.apps);
                     setTypes(values[1].data.types);
                     values[2] && setUsers(values[2]?.data.users);
                  })
                  .finally(() => setLoad(false));
               setSelect(null);
               setIP(ins.ip_addr);
               setIngress(ins.ingress_threshold);
               setAnnounceNodeIds(
                  ins.announce_instance_nodes?.map((n) => n.id) || []
               );
               onOpen();
            }}
         />
         <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Edit Filter</ModalHeader>
               <ModalCloseButton />
               <ModalBody pb={6}>
                  <Tabs index={tabIndex} isLazy>
                     <TabPanels>
                        <TabPanel p={0}>
                           <Stack spacing="3">
                              <FormControl>
                                 <FormLabel>IP Address</FormLabel>
                                 <Input
                                    mb={2}
                                    placeholder="IP Address"
                                    value={ip}
                                    isDisabled={load}
                                    onChange={(e) => setIP(e.target.value)}
                                 />
                              </FormControl>
                              {isAdmin && (
                                 <>
                                    <FormControl>
                                       <FormLabel>Provided to user</FormLabel>
                                       <Select
                                          placeholder="Select user to provided"
                                          value={owner?.id}
                                          isDisabled={load}
                                          onChange={(e) =>
                                             setOwner(
                                                users?.filter(
                                                   (t) =>
                                                      t.id === e.target.value
                                                )[0]
                                             )
                                          }
                                       >
                                          {users?.map((t) => (
                                             <option key={t.id} value={t.id}>
                                                {t.email}
                                             </option>
                                          ))}
                                       </Select>
                                    </FormControl>
                                    <Flex align="center">
                                       <Divider />
                                       <Text padding="2">Nodes</Text>
                                       <Divider />
                                    </Flex>
                                    {nodeList.map((node) => (
                                       <FormControl key={node.id}>
                                          <Checkbox
                                             name="nodes"
                                             value={node.id}
                                             onChange={(e) => {
                                                const { value, checked } =
                                                   e.target;

                                                if (checked) {
                                                   setAnnounceNodeIds([
                                                      ...announce_node_ids,
                                                      value,
                                                   ]);
                                                } else {
                                                   setAnnounceNodeIds(
                                                      announce_node_ids.filter(
                                                         (item) =>
                                                            item !== value
                                                      )
                                                   );
                                                }
                                             }}
                                             isChecked={announce_node_ids.includes(
                                                node.id
                                             )}
                                          >
                                             {node.name}{" "}
                                             {(!node.active ||
                                                !node.enable) && (
                                                <span style={{ color: "red" }}>
                                                   (Deactive)
                                                </span>
                                             )}
                                          </Checkbox>
                                       </FormControl>
                                    ))}
                                 </>
                              )}
                              <Divider />

                              <FormControl>
                                 <FormLabel>Application</FormLabel>
                                 <>
                                    <FormControl>
                                       <Button
                                          onClick={() => {
                                             setTabIndex(1);
                                          }}
                                          w="100%"
                                       >
                                          Add Application
                                       </Button>
                                    </FormControl>
                                 </>
                              </FormControl>
                              {apps.map((app, idx) => (
                                 <ApplicationCard
                                    setEdit={setEdit}
                                    setEditIndex={setEditIndex}
                                    setTabIndex={setTabIndex}
                                    apps={apps}
                                    app={app}
                                    idx={idx}
                                    setApps={setApps}
                                 />
                              ))}
                              <ModalFooter>
                                 <Button
                                    colorScheme="brand"
                                    mr={3}
                                    isDisabled={
                                       load ||
                                       !ip ||
                                       (isAdmin && announce_node_ids.length < 1)
                                    }
                                    isLoading={load}
                                    onClick={() => {
                                       setLoad(true);
                                       axios
                                          .patch(
                                             `/announces/instances/${ins.id}/v2`,
                                             {
                                                ip_addr: ip,
                                                apps: apps,
                                                user_id: owner?.id,
                                                announce_node_ids:
                                                   announce_node_ids,
                                             }
                                          )
                                          .then(() => {
                                             setLoad(false);
                                             onEdit();
                                             toast({
                                                title: `Commit success`,
                                                position: "top",
                                                status: "success",
                                                isClosable: true,
                                             });
                                          })
                                          .catch((error) => {
                                             let res = error.response;
                                             if (res) {
                                                toast({
                                                   title: res.data.message,
                                                   status: "error",
                                                   position: "top",
                                                   isClosable: true,
                                                });
                                             }
                                          })
                                          .finally(() => onClose());
                                    }}
                                 >
                                    Save
                                 </Button>
                                 <Button onClick={onClose} isDisabled={load}>
                                    Cancel
                                 </Button>
                              </ModalFooter>
                           </Stack>
                        </TabPanel>
                        <TabPanel p={0}>
                           <ApplicationForm
                              onDone={(app) => {
                                 setApps([...apps, app]);
                              }}
                              goBack={() => setTabIndex(0)}
                              apps={apps}
                           />
                        </TabPanel>
                        <TabPanel p={0}>
                           {edit && editIndex !== undefined && (
                              <ApplicationEdit
                                 app={edit}
                                 onDone={(app) => {
                                    let a = [...apps];
                                    a[editIndex] = app;
                                    setApps(a);
                                 }}
                                 goBack={() => setTabIndex(0)}
                              />
                           )}
                        </TabPanel>
                     </TabPanels>
                  </Tabs>
               </ModalBody>
            </ModalContent>
         </Modal>
      </>
   );
};
